import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppNavbar from "../components/AppNavbar";
import SideMenu from "../components/SideMenu";
import AppTheme from "../shared-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from "../theme/customizations";
import MainGridDashboard from "./dashboard/MainGridDashboard";
import { SelectedObjectProvider } from "../contexts/SelectedObjectContext";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function Dashboard(props) {
  return (
    <SelectedObjectProvider>
      <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ display: "flex" }}>
          <SideMenu />
          <AppNavbar />
          <Box
            component="main"
            sx={(theme) => ({
              flexGrow: 1,
              backgroundColor: theme.vars
                ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                : alpha(theme.palette.background.default, 1),
              overflow: "auto",
            })}
          >
            <Stack
              spacing={2}
              sx={{
                alignItems: "center",
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
              <Stack
                direction="row"
                sx={{
                  display: { xs: "none", md: "flex" },
                  width: "100%",
                  alignItems: { xs: "flex-start", md: "center" },
                  justifyContent: "space-between",
                  maxWidth: { sm: "100%", md: "1700px" },
                  pt: 1.5,
                }}
                spacing={2}
              ></Stack>
              <MainGridDashboard />
            </Stack>
          </Box>
        </Box>
      </AppTheme>
    </SelectedObjectProvider>
  );
}
